import React from 'react'
import PropTypes from 'prop-types';
import DemandCommissionForm from './DemandCommissionForm';

function Index(
    {
        expanded
    }) {
    return expanded && <DemandCommissionForm/>
}

Index.propTypes = {
    classes: PropTypes.any,
}

export default Index;